<template>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
      <b-card class="mainCardBG">
        <b-card-text>
          <b-row>
            <b-col md="4" class="my-1">
              <b-navbar-nav>
                <b-button @click="goBack" size="sm" variant="outline-secondary">
                  <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
                </b-button>
              </b-navbar-nav>
              <h5 class="mt-1 mr-2">
                {{ $route.name }}
              </h5>
            </b-col>
            <b-col md="2">
              <h5>
                <small v-if="isLoading == false">{{ totalData }} Entries</small>
              </h5>
            </b-col>
            <b-col md="4">
              <b-button class="pull-right ml-1 mt-1" :variant="Filter.booking_number ||
                Filter.container_number ||
                Filter.clientFilter ||
                Filter.slineFilter ||
                Filter.search_txt ||
                Filter.createdByFilter ||
                Filter.branchFilter ||
                Filter.dateRange.startDate ||
                Filter.dateRange.endDate ||
                Filter.StatusVerbose ||
                Filter.hasDateMismatch ||
                Filter.daysFilter
                ? 'outline-danger'
                : 'outline-primary'
                " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                  Filter.booking_number ||
                    Filter.container_number ||
                    Filter.clientFilter ||
                    Filter.slineFilter ||
                    Filter.search_txt ||
                    Filter.createdByFilter ||
                    Filter.branchFilter ||
                    Filter.dateRange.startDate ||
                    Filter.dateRange.endDate ||
                    Filter.StatusVerbose ||
                    Filter.hasDateMismatch ||
                    Filter.daysFilter
                    ? "Filter ON"
                    : "Filter OFF"
                }}</b-button>
              <b-button class="pull-right ml-1 mt-1" v-if="getTimeLineList.length > 0"
                :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                @click="getReports('getTimeLineList', 'Export As Excel')" size="sm" variant="warning"
                style="font-size: 0.675rem">
                {{ ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
            </b-col>
  
            <b-col cols="12">
              <div>
                <b-pagination limit="10" align="center" v-model="pagination.currentPage" :per-page="pagination.pageSize"
                  :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
              </div>
            </b-col>
            <b-col cols="6"> </b-col>
          </b-row>
          <div v-if="visible">
            <b-card>
              <b-collapse v-model="visible" id="collapse-2">
                <b-row>
                  <b-col md="3">
                    <label>Date</label>
                    <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                      :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                      @update="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                  </b-col>
                  <b-col md="2">
                    <label>Days</label>
                    <b-form-select v-model="Filter.daysFilter" :options="dayOptions"
                      @change="getTimeLineTrackDash('Normal', '0', '0', '1', '1'); updateDaysFilter()"
                      placeholder="Select Days" />
                  </b-col>
                  <b-col md="3">
                    <label>Booking NO Filter</label>
                    <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Booking NO Filter"
                      id="booking_number" name="booking_number" autocomplete="off" v-model="Filter.booking_number"
                      @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                  </b-col>
                  <b-col md="3">
                    <label>Container No Filter</label>
                    <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container No Filter"
                      id="container_number" name="container_number" autocomplete="off" v-model="Filter.container_number"
                      @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="3">
                    <label>Shipping Line</label>
                    <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                      v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                      placeholder="Select Shipping Line" @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')"
                      :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="3">
                    <label>Client</label>
                    <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                      v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                      placeholder="Select Client Name" @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')"
                      :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="3">
                    <label>Branch</label>
                    <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                      v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                      @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="3">
                    <label>Common Filter</label>
                    <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                      id="search_txt" name="search_txt" autocomplete="off" v-model="Filter.search_txt"
                      @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="3">
                    <label>Status Verbose</label>
                    <model-list-select :list="StatusVerboseList" v-model="Filter.StatusVerbose"
                      option-value="StatusVerboseVal" option-text="StatusVerboseTxt" placeholder="Select Status Verbose"
                      @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="3">
                    <label>Mismatch Actual/Initial</label>
                    <model-list-select :list="hasDateMismatchList" v-model="Filter.hasDateMismatch"
                      option-value="hasDateMismatchVal" option-text="hasDateMismatchTxt"
                      placeholder="Select Mismatch Actual/Initial"
                      @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="3">
                    <label>
                      <b> Created User </b>
                    </label>
                    <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                      @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                      option-value="userId" option-text="employeeName" placeholder="Select Created User"
                      :disabled="isLoading" />
                  </b-col>
  
                  <b-col md="12" class="mt-2">
                    <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                      variant="outline-danger">Reset</b-button>
                  </b-col>
                </b-row>
              </b-collapse>
            </b-card>
          </div>
          <b-row>
            <b-col v-for="(item, index) in getTimeLineList" :key="index" cols="12" class="mb-3">
              <b-card class="animated-border-card shadow-md rounded-xl border-light" :style="{
                background: 'linear-gradient(to right, #f8f9fa, #eef1f5)',
                transition: 'all 0.3s ease',
                border: '0.5px solid #dee2e6',
                padding: '0.25rem',
                fontsize: '8px'
              }">
  
                <!-- Header -->
                <b-row class="align-items-center mb-1" style="font-size: 0.675rem">
                  <b-col cols="6">
                    <small class="text-primary">
                      #{{ index + 1 + (pagination.currentPage - 1) * pagination.pageSize }}
                    </small>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button variant="link" size="sm" style="font-size: 0.675rem"
                      class="text-primary text-sm float-right" v-b-toggle="'track-' + index">
                      <i class="bi bi-chevron-down small mr-1"></i> View Full Timeline
                    </b-button>
                    <b-badge variant="info" class="text-capitalize shadow-sm">
                      {{ item.StatusVerbose }}
                    </b-badge>
                  </b-col>
                </b-row>
  
                <!-- Main Info -->
                <b-row class="text-sm">
                  <!-- Booking Details -->
                  <b-col md="3">
                    <h6 class="text-primary mb-1">
                      <i class="bi bi-journal-bookmark mr-1"></i> Booking
                    </h6>
                    <b>Booking No:</b>
                    <span :style="item.subscription_id ? 'color:#007bff;font-weight:bold;cursor:pointer' : ''"
                      @click="item.subscription_id ? goToSubscriptionPage(item) : ''">
                      {{ item.BookingNumber }}
                    </span><br />
                    <b>Job No:</b> {{ item.JobNo }}<br />
                    <b>Job Date:</b> {{ item.JobDate }}<br />
                    <b>Raised By:</b> {{ item.RaisedBy }}<br />
                    <b>Client:</b> {{ item.ClientName }}<br />
                    <b>Sline:</b> {{ item.SlineName }}<br />
                    <b>Mbl No:</b> {{ item.BlType }} | {{ item.MblNo }}<br />
                    <b>MBL Date:</b> {{ item.MblDate }}<br />
                    <b>Mbl Release:</b> {{ item.MblReleaseDate }}<br />
                    <b>IncoTerm:</b> {{ item.IncoTerm }}<br />
                    <b>BrfNo:</b> {{ item.BrfNo }}<br />
                    <b v-if="tabName == 'Leg 1 Changed'">
                      Leg 1 Old → Current: {{ item.old_leg1_vessel_name }} → {{
                        item.current_leg1_vessel_name }}</b>
                    <b v-if="tabName == 'Leg 2 Changed'">
                      Leg 2 Old → Current: {{ item.old_leg2_vessel_name }} → {{
                        item.current_leg2_vessel_name }}</b>
                    <b v-if="tabName == 'SOB Changed'">
                      SOB Old → Current: {{ item.old_SobPlanDetected }} → {{ item.current_SobPlanDetected }}<br>
  
                    </b>
                    <b v-if="tabName.startsWith('SOB ')">
                      SOB Planned Initial: {{ item.old_SobPlanInitial }} → {{ item.current_SobPlanInitial }}<br>
                      SOB Planned Last: {{ item.old_SobPlanLast }} → {{ item.current_SobPlanLast }}<br>
                      SOB Actual: {{ item.old_SobPlanActual }} → {{ item.current_SobPlanActual }}<br>
                      SOB Detected: {{ item.old_SobPlanDetected }} → {{ item.current_SobPlanDetected }}<br>
  
                    </b>
  
      
                    <b v-if="tabName == 'POL Changed'">
                      POL Arrival Planned Initial: {{ item.old_pol_arrival_planned_initial }} → {{
                        item.current_pol_arrival_planned_initial }}<br />
                      POL Arrival Actual: {{ item.old_pol_arrival_actual }} → {{ item.current_pol_arrival_actual }}<br />
                      Days Diff: {{ item.current_pol_arrival_days_diff }}
                    </b>
                    <b v-if="tabName.startsWith('POL ') && tabName.includes('Arrival')">
                      POL Arrival Planned Initial: {{ item.old_pol_arrival_planned_initial }} → {{ item.current_pol_arrival_planned_initial }}<br>
                      POL Arrival Actual: {{ item.old_pol_arrival_actual }} → {{ item.current_pol_arrival_actual }}<br>
                      Days Diff: {{ item.current_pol_arrival_days_diff }}
                    </b>
                    <b v-if="tabName.startsWith('POL ') && tabName.includes('Departure')">
                      POL Departure Planned Initial: {{ item.old_pol_departure_planned_initial }} → {{ item.current_pol_departure_planned_initial }}<br>
                      POL Departure Actual: {{ item.old_pol_departure_actual }} → {{ item.current_pol_departure_actual }}<br>
                      Days Diff: {{ item.current_pol_departure_days_diff }}
                    </b>
                    <b v-if="tabName == 'POD Plan Changed'">
                      POD VSL Arrival Planned Initial: {{ item.old_pod_vslarrival_planned_initial }} → {{
                        item.current_pod_vslarrival_planned_initial }}<br />
                      POD VSL Arrival Actual: {{ item.old_pod_vslarrival_actual }} → {{ item.current_pod_vslarrival_actual
                      }}<br />
                      Days Diff: {{ item.current_pod_vslarrival_days_diff }}
                    </b>
                    <b v-if="tabName == 'POD Departure Changed'">
                      POD Departure Planned Initial: {{ item.old_pod_departure_planned_initial }} → {{
                        item.current_pod_departure_planned_initial }}<br />
                      POD Departure Actual: {{ item.old_pod_departure_actual }} → {{ item.current_pod_departure_actual
                      }}<br />
                      Days Diff: {{ item.current_pod_departure_days_diff }}
                    </b>
                    <b v-if="tabName.startsWith('POD ') && tabName.includes('Arrival')">
                      POD Arrival Planned Initial: {{ item.old_pod_arrival_planned_initial }} → {{ item.current_pod_arrival_planned_initial }}<br>
                      POD Arrival Actual: {{ item.old_pod_arrival_actual }} → {{ item.current_pod_arrival_actual }}<br>
                      Days Diff: {{ item.current_pod_arrival_days_diff }}
                    </b>
                    <b v-if="tabName.startsWith('POD ') && tabName.includes('Departure')">
                      POD Departure Planned Initial: {{ item.old_pod_departure_planned_initial }} → {{ item.current_pod_departure_planned_initial }}<br>
                      POD Departure Actual: {{ item.old_pod_departure_actual }} → {{ item.current_pod_departure_actual }}<br>
                      Days Diff: {{ item.current_pod_departure_days_diff }}
                    </b>
                    <b v-if="tabName == 'DLV Arrival'">
                      DLV Delivery Planned Initial: {{ item.old_dlv_delivery_planned_initial }} → {{
                        item.current_dlv_delivery_planned_initial }}<br />
                      DLV Delivery Actual: {{ item.old_dlv_delivery_actual }} → {{ item.current_dlv_delivery_actual
                      }}<br />
                      Days Diff: {{ item.current_dlv_delivery_days_diff }}
                    </b>
                    <b v-if="tabName.startsWith('DLV ') && tabName.includes('Arrival')">
                      DLV Arrival Planned Initial: {{ item.old_dlv_arrival_planned_initial }} → {{ item.current_dlv_arrival_planned_initial }}<br>
                      DLV Arrival Actual: {{ item.old_dlv_arrival_actual }} → {{ item.current_dlv_arrival_actual }}<br>
                      Days Diff: {{ item.current_dlv_arrival_days_diff }}
                    </b>
                    <b v-if="tabName == 'TSP4 Departure Changed'">
                      TSP4 VSL Departure Planned Initial: {{ item.old_tsp4_vsldeparture_planned_initial }} → {{
                        item.current_tsp4_vsldeparture_planned_initial }}<br />
                      TSP4 VSL Departure Actual: {{ item.old_tsp4_vsldeparture_actual }} → {{
                        item.current_tsp4_vsldeparture_actual }}<br />
                      Days Diff: {{ item.current_tsp4_vsldeparture_days_diff }}
                    </b>
                    <b v-if="tabName == 'TSP4 Arrival'">
                      TSP4 VSL Arrival Planned Initial: {{ item.old_tsp4_vslarrival_planned_initial }} → {{
                        item.current_tsp4_vslarrival_planned_initial }}<br />
                      TSP4 VSL Arrival Actual: {{ item.old_tsp4_vslarrival_actual }} → {{
                        item.current_tsp4_vslarrival_actual }}<br />
                      Days Diff: {{ item.current_tsp4_vslarrival_days_diff }}
                    </b>
                    <b v-if="tabName == 'TSP1 Changed'">
                      TSP1 VSL Departure Planned Initial: {{ item.old_tsp1_vsldeparture_planned_initial }} → {{
                        item.current_tsp1_vsldeparture_planned_initial }}<br />
                      TSP1 VSL Departure Actual: {{ item.old_tsp1_vsldeparture_actual }} → {{
                        item.current_tsp1_vsldeparture_actual }}<br />
                      Days Diff: {{ item.current_tsp1_vsldeparture_days_diff }}
                    </b>
                    <b v-if="tabName == 'TSP1 Arrival'">
                      TSP1 VSL Arrival Planned Initial: {{ item.old_tsp1_vslarrival_planned_initial }} → {{
                        item.current_tsp1_vslarrival_planned_initial }}<br />
                      TSP1 VSL Arrival Actual: {{ item.old_tsp1_vslarrival_actual }} → {{
                        item.current_tsp1_vslarrival_actual }}<br />
                      Days Diff: {{ item.current_tsp1_vslarrival_days_diff }}
                    </b>
                    <b v-if="tabName == 'TSP2 Departure Changed'">
                      TSP2 VSL Departure Planned Initial: {{ item.old_tsp2_vsldeparture_planned_initial }} → {{
                        item.current_tsp2_vsldeparture_planned_initial }}<br />
                      TSP2 VSL Departure Actual: {{ item.old_tsp2_vsldeparture_actual }} → {{
                        item.current_tsp2_vsldeparture_actual }}<br />
                      Days Diff: {{ item.current_tsp2_vsldeparture_days_diff }}
                    </b>
                    <b v-if="tabName == 'TSP2 Arrival'">
                      TSP2 VSL Arrival Planned Initial: {{ item.old_tsp2_vslarrival_planned_initial }} → {{
                        item.current_tsp2_vslarrival_planned_initial }}<br />
                      TSP2 VSL Arrival Actual: {{ item.old_tsp2_vslarrival_actual }} → {{
                        item.current_tsp2_vslarrival_actual }}<br />
                      Days Diff: {{ item.current_tsp2_vslarrival_days_diff }}
                    </b>
                  </b-col>
  
                  <!-- Location Details -->
                  <b-col md="3">
                    <h6 class="text-success mb-1">
                      <i class="bi bi-geo-alt mr-1"></i> Location
                    </h6>
                    <b>From:</b> {{ item.RaisedFrom }}<br />
                    <b>Empty Pickup:</b> {{ item.EmptyPickupLoc }}<br />
                    <b>Origin → POL:</b> {{ item.OriginLoc }} → {{ item.PolLoc }}<br />
                    <b>POD → DLV:</b> {{ item.PodLoc }} → {{ item.DlvLoc }}<br />
                    <b>Empty Return:</b> {{ item.EmptyReturnLoc }}<br />
                    <b>Tsp1 → Tsp2:</b> {{ item.Tsp1Loc }} → {{ item.Tsp2Loc }}<br />
                    <b>Tsp3 → Tsp4:</b> {{ item.Tsp3Loc }} → {{ item.Tsp4Loc }}<br />
                  </b-col>
  
                  <!-- Status -->
                  <b-col md="3">
                    <h6 class="text-warning mb-1">
                      <i class="bi bi-box-seam mr-1"></i> Status
                    </h6>
                    <b>Container:</b> {{ item.container_number }}<br />
                    <b>Vessel 1 → Voyage 1:</b> {{ item.Vessel1 }} → {{ item.Voyage1 }}<br />
                    <b>Vessel 2 → Voyage 2:</b> {{ item.Vessel2 }} → {{ item.Voyage2 }}<br />
                    <b>Status Msg:</b> {{ item.EventMessage }}<br />
                    <b>Status Verbose:</b> {{ item.StatusVerbose }}<br />
                  </b-col>
  
                  <!-- SOB -->
                  <b-col md="3">
                    <h6 class="text-danger mb-1">
                      <i class="bi bi-flag-fill mr-1"></i> SOB
                    </h6>
                    <b>Arrival Plan → Actual:</b> {{ item.SobPlanInitial }} → {{ item.PolPlanActual }}<br />
                    <b>Departure Plan → Actual:</b> {{ item.SobPlanActual }} → {{ item.SobPlanDetected }}<br />
                    <b>SI:</b> {{ item.SiCB }} → {{ item.SiMain }}<br />
                    <b>VGM:</b> {{ item.VgmCb }} → {{ item.VgmMain }}<br />
                    <b>TR:</b> {{ item.TrCb }} → {{ item.TrMain }}<br />
                    <b>Hand:</b> {{ item.HandoverCB }} → {{ item.HandoverMain }}<br />
                  </b-col>
                </b-row>
  
                <b-collapse :id="'track-' + index" accordion="track-accordion" class="mt-2 ">
                  <b-row class="text-sm g-2">
                    <b-col md="3" class="bg-light p-2 rounded border border-primary mb-1">
                      <h6 class="text-primary"><i class="bi bi-box-seam"></i> Empty Pickup</h6>
                      <b>Arrival Plan → Last:</b> {{ item.EmptyPickupPlanInitial }} → {{ item.EmptyPickupPlanLast }}<br />
                      <b>Departure Actual:</b> {{ item.EmptyPickupPlanActual }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-success mb-1">
                      <h6 class="text-success"><i class="bi bi-box-seam"></i> Origin</h6>
                      <b>Arrival Plan → Last:</b> {{ item.OriginPlanInitial }} → {{ item.OriginPlanLast }}<br />
                      <b>Departure Actual:</b> {{ item.OriginPlanActual }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-info mb-1">
                      <h6 class="text-info"><i class="bi bi-box-seam"></i> POL</h6>
                      <b>Arrival Plan → Last:</b> {{ item.PolPlanInitial }} → {{ item.PolPlanLast }}<br />
                      <b>Departure Actual:</b> {{ item.PolPlanActual }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-warning mb-1">
                      <h6 class="text-warning"><i class="bi bi-box-seam"></i> POD</h6>
                      <b>Arrival Plan → Actual:</b> {{ item.PodPlanInitial }} → {{ item.PodPlanActual }}<br />
                      <b>Departure Plan → Actual:</b> {{ item.PodDepartureInitial }} → {{ item.PodDepartureActual }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-danger mb-1">
                      <h6 class="text-danger"><i class="bi bi-box-seam"></i> TSP1</h6>
                      <b>Arrival Plan → Actual:</b> {{ item.Tsp1PlanInitial }} → {{ item.Tsp1PlanActual }}<br />
                      <b>Departure Plan → Actual:</b> {{ item.Tsp1DepartureInitial }} → {{ item.Tsp1DepartureActual
                      }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-secondary mb-1">
                      <h6 class="text-secondary"><i class="bi bi-box-seam"></i> TSP2</h6>
                      <b>Arrival Plan → Actual:</b> {{ item.Tsp2PlanInitial }} → {{ item.Tsp2PlanActual }}<br />
                      <b>Departure Plan → Actual:</b> {{ item.Tsp2DepartureInitial }} → {{ item.Tsp2DepartureActual
                      }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-dark mb-1">
                      <h6 class="text-dark"><i class="bi bi-box-seam"></i> TSP3</h6>
                      <b>Arrival Plan → Actual:</b> {{ item.Tsp3PlanInitial }} → {{ item.Tsp3PlanActual }}<br />
                      <b>Departure Plan → Actual:</b> {{ item.Tsp3DepartureInitial }} → {{ item.Tsp3DepartureActual
                      }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-primary mb-1">
                      <h6 class="text-primary"><i class="bi bi-box-seam"></i> TSP4</h6>
                      <b>Arrival Plan → Actual:</b> {{ item.Tsp4PlanInitial }} → {{ item.Tsp4PlanActual }}<br />
                      <b>Departure Plan → Actual:</b> {{ item.Tsp4DepartureInitial }} → {{ item.Tsp4DepartureActual
                      }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-success mb-1">
                      <h6 class="text-success"><i class="bi bi-box-seam"></i> Empty Return</h6>
                      <b>Arrival Plan → Last:</b> {{ item.EmptyReturnPlanInitial }} → {{ item.EmptyReturnPlanLast }}<br />
                      <b>Departure Actual:</b> {{ item.EmptyReturnPlanActual }}<br />
                    </b-col>
  
                    <b-col md="3" class="bg-light p-2 rounded border border-info mb-1">
                      <h6 class="text-info"><i class="bi bi-box-seam"></i> Pridel Prediction</h6>
                      <!-- Add predictions if available -->
                    </b-col>
                  </b-row>
                </b-collapse>
  
  
              </b-card>
            </b-col>
          </b-row>
  
          <div>
            <b-pagination limit="10" align="center" v-model="pagination.currentPage" :per-page="pagination.pageSize"
              :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
          </div>
        </b-card-text>
      </b-card>
  
      <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    </div>
  </template>
  
  <script>
  import DatePicker from "vue2-datepicker";
  import CustomLoader from "../common/customLoader.vue";
  import { DateFormat, selectDateFormat } from "../../helper/filters";
  import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
  import DateRangePicker from "vue2-daterange-picker";
  import TrasportService from "../../services/TrasportService";
  import { ModelListSelect, MultiSelect } from "vue-search-select";
  import Multiselect from "vue-multiselect";
  import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
  
  import ShipmentTimeline from "./ShipmentTimeline.vue"
  
  export default {
    name: "milestoneTrack",
    props: {
      daysFilter: { type: String, default: '' },
      tabName: { type: String, default: '' },
      tabIndex: { type: Number, default: 0 },
      tab: { type: Object, default: () => ({}) }
    },
    model: {
      prop: 'daysFilter',
      event: 'input',
    },
    beforeMount() {
      lastVisitPage(this.$router.history.current.fullPath);
  
      const storePromises = [
        this.$store.dispatch(
          "common/setAllUserList",
          JSON.stringify({
            itemCode: "GET_USERLIST_Data",
          })
        ),
        this.$store.dispatch(
          "common/setAllBranchList",
          JSON.stringify({
            filter: "BranchList",
            active: "all",
          })
        ),
  
        this.$store.dispatch(
          "common/setAllClientList",
          JSON.stringify({ itemCode: "ClientList" })
        ),
        this.$store.dispatch(
          "common/setAllShippingLineList",
          JSON.stringify({ itemCode: "ShippingLineList" })
        ),
  
      ];
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      Promise.all(storePromises)
        .then(() => delay(1000))
        .then(() => {
          console.log("All store actions completed.");
        })
        .catch((error) => {
          console.error("Error dispatching store actions:", error);
        });
  
      this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
      this.getCurrentLastDate();
  
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
      }
    },
    mounted() {
      console.log('Tab name from parent:', this.tabName);
      console.log('Tab tabIndex from parent:', this.tabIndex);
      console.log('Tab daysFilter from parent:', this.daysFilter);
      console.log('Tab tab from parent:', this.tab);
    },
    filters: {
      moment(date) {
        return DateFormat(date);
      },
    },
  
    beforeDestroy() { },
  
    destroyed() { },
    data() {
      return {
        localDaysFilter: this.daysFilter || '',
        dayOptions: Array.from({ length: 30 }, (_, i) => ({ value: i + 1, text: `${i + 1} Day(s)` })),
        docURL: URL_BASE_DOC,
        selectDateFormat,
        lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
        ExcelBtnName: "Export As Excel",
        visible: false,
        getTimeLineList: [],
        totalData: 0,
        StatusVerboseList: [{
          StatusVerboseVal: "1",
          StatusVerboseTxt: "Running",
        }, {
          StatusVerboseVal: "2",
          StatusVerboseTxt: "Completed",
        }, {
          StatusVerboseVal: "3",
          StatusVerboseTxt: "All",
        }],
        hasDateMismatchList: [{
          hasDateMismatchVal: "1",
          hasDateMismatchTxt: "Mismatch",
        }, {
          hasDateMismatchVal: "2",
          hasDateMismatchTxt: "All",
        }],
        pagination: {
          currentPage: 1,
          pageSize: 10,
          totalPages: 0,
          totalCounts: 0,
        },
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
  
        Filter: this.getDefaultFilter(),
        //Added By Priyanshu Singh Multi Select Start
  
        openLeft: "left",
        showCal: false,
        startDate: "2017-09-05",
        endDate: "2017-09-15",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        locale: {
          direction: "ltr",
          format: "mm/dd/yyyy",
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          monthNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          firstDay: 0,
        },
        alert: {
          content: "Are you sure you want to delete ..!",
          ok: "ok",
        },
        value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
        value2: [],
        langType: {
          pickers: ["Today", "Yesterday", "This Month", "This Year"],
        },
        time: "",
        date: "",
        week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
  
        langEnq: {
          pickers: ["", "", "previous 7 days", "previous 30 days"],
        },
        isLoading: false,
        generateExcel: "0",
      };
    },
  
    components: {
      CustomLoader,
      DatePicker,
      ModelListSelect,
      DateRangePicker,
  
      MultiSelect,
      Multiselect,
      ShipmentTimeline,
    },
    computed: {},
    watch: {},
    methods: {
      // Helper to get default filter object
      getDefaultFilter() {
        return {
          booking_number: "",
          container_number: "",
          clientFilter: "",
          slineFilter: "",
          search_txt: "",
          createdByFilter: "",
          branchFilter: "",
          dateRange: {
            startDate: "",
            endDate: "",
          },
          startDate: "",
          endDate: "",
          StatusVerbose: "1",
          hasDateMismatch: "1",
          daysFilter: this.daysFilter || "2",
        };
      },
      // Emit daysFilter change for v-model
      updateDaysFilter() {
        this.$emit('input', this.Filter.daysFilter);
      },
      goToSubscriptionPage(item) {
        if (item.subscription_id) {
          this.$router.push({
            path: "/tracking/ocean-insights/subscription/" + item.subscription_id,
          });
        }
      },
      clearFilter() {
        this.Filter = this.getDefaultFilter();
        this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
      },
      getCurrentLastDate() {
        var today = new Date();
        var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  
        var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
        var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
        var firstDay_yyyy = firstDay.getFullYear();
  
        var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
        var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
        var lastDay_yyyy = lastDay.getFullYear();
  
        firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
        lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
  
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + "/" + mm + "/" + dd; //2018-06-01
        this.startDate = today;
        this.Filter.dateRange = {
          startDate: firstDay,
          endDate: lastDay,
        };
      },
  
      getTimeLineTrackDash(type, filterIdD, CURRENT, SEARCH, pageNumber) {
        console.log('getTimeLineTrackDashTab name from parent:', this.tabName);
        console.log('getTimeLineTrackDashTab tabIndex from parent:', this.tabIndex);
        this.totalData = 0;
        this.getTimeLineList = [];
        let payload = {};
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getTimeLineList",
          type: type,
          currentPage: this.pagination.currentPage,
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          filter: this.Filter,
          generateExcel: this.generateExcel,
          isAll: this.generateExcel,
          search_txt: this.Filter.search_txt,
          tabName: this.tabName,
          tabIndex: this.tabIndex,
        };
  
        const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
  
        TrasportService.getMilestoneSubscriptionTrack(payload, config)
          .then((response) => {
            const { data, status, statusText } = response;
  
            if (status == 200 && data) {
              if (this.generateExcel == "1") {
  
                const blob = new Blob([data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "TrackReport.xlsx");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
  
                this.ExcelBtnName = "Export As Excel";
                this.generateExcel = "0";
                this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
              } else {
                if (data.data.length > 0) {
                  this.pagination = data.pagination;
                  this.totalData = data.pagination.totalCounts[0].totalCount
                  this.getTimeLineList = data.data;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            this.$bvToast && this.$bvToast.toast('Failed to load timeline data. Please try again.', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
            console.error('Catch on getTimeLineList Error: ', error);
          });
      },
      onFiltered(filtered) {
        this.totalRows = filtered.length;
        this.pagination.currentPage = 1;
      },
      clearTimeout() { },
      goBack() {
        window.history.go(-1);
      },
  
      debounceSearch(event) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
        }, 1000);
      },
      getReports(id, btnName) {
        this.isLoading = true;
        this.generateExcel = "1";
        this.ExcelBtnName = "Downloading Please Wait .....";
        this.getTimeLineTrackDash("Excell", "0", "0", "1", "1");
      },
      fetchLastPage(event) {
        let CURRENT = 0;
        if (event == "1") {
          CURRENT = 0;
        } else {
          CURRENT = parseInt(event) * this.pagination.pageSize - this.pagination.pageSize;
        }
        this.getTimeLineTrackDash("Normal", "0", CURRENT, "2", event);
      },
      onPageChange: function (event) {
        console.log("event=>", event);
        this.pagination.currentPage = event;
        this.$sessionsStorage.set("lastVisitPage", event);
        this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
        let CURRENT = 0;
        if (event == "1") {
          CURRENT = 0;
        } else {
          CURRENT = event * this.pagination.pageSize - this.pagination.pageSize;
        }
        this.getTimeLineTrackDash("Normal", "0", CURRENT, "2", event);
      },
    },
  };
  </script>
  
  <style scoped>
  .hover-shadow:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: 0.3s;
  }
  
  .animated-border-card {
    position: relative;
    overflow: hidden;
    z-index: 0;
  }
  
  .animated-border-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border: 2px solid transparent;
    background: linear-gradient(120deg, #007bff, #00c2ff, #007bff);
    background-size: 200% 200%;
    animation: borderAnimation 4s linear infinite;
    z-index: -1;
    pointer-events: none;
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
    -webkit-mask-composite: destination-out;
    padding: 2px;
  }
  
  @keyframes borderAnimation {
    0% {
      background-position: 0% 50%;
    }
  
    50% {
      background-position: 100% 50%;
    }
  
    100% {
      background-position: 0% 50%;
    }
  }
  
  /* Add :disabled style for filter controls */
  [disabled],
  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }
  </style>
  


// WEBPACK FOOTER //
// milestoneTrack.vue?9ef7512a